import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactTable from "react-table";
import Pagination from '../../../pagination/pagination';
import withAuth from '../../../AuthHOC/withAuth';
import { connect } from 'react-redux';
import { fetchallUsersReport } from '../../../../actions/reports';
import Loader from '../../../loader/loader';
import moment from 'moment';
import Modal from 'react-responsive-modal';
import Calendar from 'rc-calendar';
import DatePicker from 'rc-calendar/lib/Picker';
import 'rc-calendar/assets/index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { API_BASE_URL, getHeaders,getOrgId } from '../../../../constants/index';
import swal from 'sweetalert2/dist/sweetalert2.js';
import axios from 'axios';

const now = moment();
const before = moment().subtract(7, 'd');
const format = 'YYYY-MM-DD';

class AllUsersReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
        this.setLoading = this.setLoading.bind(this);
    }

    setLoading(val) {
        this.setState({ loading: val });
    }

    componentWillMount() {
        this.props.fetchallUsersReport();
    }
    exportUsersRecordToCSV() {

        let user = JSON.parse(localStorage.getItem('user'));
        let organisation_id = user.current_org;
        this.setLoading(true);
        // axios.get(`${API_BASE_URL}/v1/auth/users/bankrecords/${getUserId()}/organisation/${organisation_id}/reports/bankrecords/csv`, {
        axios.get(`${API_BASE_URL}/v1/auth/organisation/${getOrgId()}/users/all`, {

            // headers: {
            //     'Content-Type': 'application/json',
            //     'X-Requested-With': 'XMLHttpRequest',
            //     'Access-Control-Allow-Origin': '*',
            //     'Authorization': 'Bearer ' + user.access_token,
            // },
            headers: getHeaders(),
            responseType: 'blob'

        }).then((response) => {
            this.setLoading(false);
            const mimeType = format === 'excel'
                ? 'application / vnd.openxmlformats - officedocument.spreadsheetml.sheet'
                : format === 'csv'
                    ? 'text/csv'
                    : format === 'pdf'
                        ? 'application/pdf'
                        : '';

            const fileExtension = format === 'excel'
                ? 'xlsx'
                : format === 'csv'
                    ? 'csv'
                    : format === 'pdf'
                        ? 'pdf'
                        : '';

            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
            link.download = `All Users Record-Report.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            swal(
                'Success',
                'Download Report Success',
                'success'
            );
        }).catch((error) => {
            this.setLoading(true);
            console.log(error);
        })
    }


    render() {
        //console.log('ALl USERS Props: ', this.props);

        const columns = [{
            Header: 'User Name',
            Cell: row => (
                <div>
                    {row.original.username}
                </div>
            )
        }, {
            Header: 'Email',
            Cell: row => (
                <div className="match">
                    <span className="highlight" style={{ fontSize: 'inherit' }}>{row.original.email_address}</span>

                </div>
            )
        },
        {
            Header: 'Contact',
            Cell: row => (
                <div className="match">
                    <span className="highlight" style={{ fontSize: 'inherit' }}>{row.original.phone}</span>

                </div>
            )
        },
        {
            Header: 'Status',
            Cell: row => (
                <div>
                    {row.original.active ===1 ? 'Active':'Inactive'}
                </div>

            )
        }];

        return (
            <div className="bank-report">
                {this.props.loading && <Loader />}
                <div className="page-head mb_30">
                    <div className="head">
                        <h1 className="page-title">Users</h1>
                        <nav>
                            <ol className="breadcrumb page-title">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item current">Users</li>
                            </ol>
                        </nav>
                    </div>
                    <div className="actions">
                        <button className="btn btn-orange" onClick={() => this.exportUsersRecordToCSV()}>Export to CSV</button>
                    </div>
                </div>
                <div className="box">
                    <div className="table-area">
                        <ReactTable
                            PaginationComponent={Pagination}
                            data={this.props.data}
                            columns={columns}
                            noDataText="No Users Report Found."
                            defaultPageSize={10}
                            resizable={true}
                            minRows={5}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapsDispatchToProps(dispatch) {
    return {
        fetchallUsersReport: () => dispatch(fetchallUsersReport()),

    }
}

function mapsStateToProps(state) {
    return {
        loading: state.reports.loader,
        data: state.reports.allUsers_data,
    }
}

export default connect(() => (mapsStateToProps), mapsDispatchToProps)(withAuth(AllUsersReport, ['administrator']));